import { render, staticRenderFns } from "./DrawerGroup.vue?vue&type=template&id=3ae78cbf&"
import script from "./DrawerGroup.vue?vue&type=script&lang=js&"
export * from "./DrawerGroup.vue?vue&type=script&lang=js&"
import style0 from "./DrawerGroup.vue?vue&type=style&index=0&id=3ae78cbf&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports